import { RoundStepperProps } from 'src/components/tournaments/RoundStepper';

export type CalculatePrizesParams = Pick<
  RoundStepperProps,
  'roundPrizes' | 'roundsCount'
>;

export function calculatePrizes({
  roundPrizes = [],
  roundsCount,
}: CalculatePrizesParams) {
  const finalRoundPrize = {
    win: roundPrizes[0],
    loss: roundPrizes[1],
  };

  const prizes = [...new Array(roundsCount).fill(undefined)];
  roundPrizes
    .slice(1, Math.min(roundPrizes.length, roundsCount))
    .map((roundPrize, i) => {
      prizes[prizes.length - 1 - i] = roundPrize;
    });
  return { prizes, finalRoundPrize };
}
